import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { UserService } from 'app/core/services/user.service';
import { User } from '@app/shared/models';
import { Log } from 'ng2-logger';

@Component({
    selector: 'app-tool-responsible-form',
    templateUrl: 'tool-properties-form.component.html',
    styleUrls: ['tool-properties-form.component.scss']
})
export class ToolPropertiesFormComponent implements OnInit {
    _logger = Log.create(ToolPropertiesFormComponent.name);

    @Input() owners: User[];
    @Input() showValidations = false;

    form: UntypedFormGroup;
    selectedOwner: User;

    constructor(private userService: UserService) {
    }

    ngOnInit() {
        this.form = new UntypedFormGroup({
            owner: new UntypedFormControl(null),
            validForProduction: new UntypedFormControl(null),
            notValidForProduction: new UntypedFormControl(null),
            validityReason: new UntypedFormControl(null),
        });
        this.getOwners();

        this.form.get('validForProduction')?.valueChanges.subscribe(() => {
            this.updateValidityReasonRequirement();
        });

        this.form.get('notValidForProduction')?.valueChanges.subscribe(() => {
            this.updateValidityReasonRequirement();
        });
    }

    onSelectedOwner(owner: User) {
        this._logger.info('onSelectedOwner:: Selected owner', this.selectedOwner);
        this.selectedOwner = owner;
    }

    resetForm() {
        this._logger.info('resetForm:: Resetting data');
        this.form.reset();
    }

    control(name: string) {
        return this.form?.get(name);
    }

    onProductionValidityChanged(toolProductionValidity: boolean) {
        if (toolProductionValidity === true) {
            this.form.controls.notValidForProduction.setValue(null);
        } else {
            this.form.controls.validForProduction.setValue(null);
        }
    }

    get isProductionValidityChanged() {
        return this.form?.controls?.validForProduction?.value === true ||
            this.form?.controls?.notValidForProduction?.value === true;
    }

    get valid() {
        return this.form.valid;
    }

    get value() {
        return this.form.value;
    }

    private getOwners() {
        this.userService.getUsers().subscribe((data) => {
            this.owners = data.users;
        });
    }

    private updateValidityReasonRequirement() {
        const validityReasonControl = this.form.get('validityReason');

        if (this.isProductionValidityChanged) {
            validityReasonControl?.setValidators([Validators.required]);
        } else {
            validityReasonControl?.clearValidators();
        }

        validityReasonControl?.updateValueAndValidity();
    }

}
